import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  label: {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(0.75),
    color: theme.palette.text.secondary,
  },
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 40,
    padding: theme.spacing(0, 2),
    borderRadius: 20,
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    fontSize: 14,
  },
  help: {
    fontSize: 12,
    color: theme.palette.text.hint,
    marginTop: theme.spacing(0.5),
  },
}));
